import React from 'react';
import { AppointmentConfirmationCard } from '../../../../../../components/AppointmentConfirmationCard';

import { ReactComponent as CheckupExecutiveSM } from '../../../../../../assets/check-up-sm.svg';
import { HeadProduct } from '../../../../../../components/HeadProduct';
import { HorizontalLine } from '../../../../../../components/HorizontalLine';

import { ReactComponent as StethoscopeIcon } from '../../../../../../assets/stethoscope.svg';

export type ScheduleCard = {
  patientName: string;
  specialistName: string;
  specialties: string;
  unitName: string;
  unitAddress: string;
  isTelemedicine: boolean;
  dateTime: Date;
};

export const ScheduleCard = (props: ScheduleCard) => {
  // const slots = schedule?.selectedSlotOptions?.[0];

  // if (!slots) return null;

  // let address = schedule.unit?.address || '';

  // if (schedule?.unit?.number) address = address + `, ${schedule.unit.number}`;
  // if (schedule?.unit?.neighborhood) address = address + `, ${schedule.unit.neighborhood}`;
  // if (schedule?.unit?.city) address = address + `, ${schedule.unit.city}`;
  // if (schedule?.unit?.state) address = address + ` - ${schedule.unit.state}`;

  return (
    <AppointmentConfirmationCard
      patientName={props.patientName ?? ''}
      productName={props.specialistName}
      productNameHead={props.specialistName}
      productIconSM={<CheckupExecutiveSM />}
      eligibility={''}
      date={props.dateTime}
      productDescription="Check-up"
      unitName={props.unitName}
      unitAddress={props.unitAddress}
      telemedicine={props.isTelemedicine}
      customCardHead={
        <>
          <HeadProduct name={props.specialistName} description={props.specialties} productIcon={<StethoscopeIcon />} />
          <HorizontalLine />
        </>
      }
    />
  );
};
